import React from "react";
import './style.less'
import { Row, Col, Image } from 'antd'

export default class HowToMakeAClaim extends React.Component {
    render() {
        const gutter = {
            xs: 8, sm: 16, md: 24, lg: 32
        }
       
        const list = [
            {
                key: 1,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/6.png",
                desc: "提供飞行现场的视频证据"
            },
            {
                key: 2,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/7.png",
                desc: "保险公司收到事故证据，审查并记录"
            },
            {
                key: 3,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/8.png",
                desc: "设备运回制造商返修"
            },
            {
                key: 4,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/9.png",
                desc: "制造商评估设备的损坏情况"
            },
            {
                key: 5,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/10.png",
                desc: "保险公司评估损失并确认赔付"
            },
            {
                key: 6,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/11.png",
                desc: "制造商收到赔偿并开始维修"
            },
            {
                key: 7,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/12.png",
                desc: "维修后运输和发货"
            },
            {
                key: 8,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/5.png",
                desc: "理赔完成"
            },
        ]
        return (
            <div className={'how-to-make-a-claim'}>
                <h1>如何理赔？</h1>
                <div className={'buy-process'}>
                    <Row justify="center">
                        {
                            list.map(item => {
                                return <Col className="col-item" xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                                    <div className="item-box">
                                        <div className="num">{item.key}</div>
                                        <div className="icon-img">
                                            <Image preview={false} src={item.bgSrc} />
                                        </div>
                                        <p className={`item-desc${item.key}`}>{item.desc}</p>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>

                </div>
            </div>
        )
    }
}
